import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root no encontrado en el DOM');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Registrar el service worker solo en producción — en dev Vite hace HMR propio.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* no-op */
    });
  });
}
